/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StbGroupByDeviceTypeResponse
 */
export interface StbGroupByDeviceTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof StbGroupByDeviceTypeResponse
     */
    name?: string;
}

export function StbGroupByDeviceTypeResponseFromJSON(json: any): StbGroupByDeviceTypeResponse {
    return StbGroupByDeviceTypeResponseFromJSONTyped(json, false);
}

export function StbGroupByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StbGroupByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function StbGroupByDeviceTypeResponseToJSON(value?: StbGroupByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

